import React from 'react';

const BasicCard = ({ children }: { children: React.ReactNode }) => {
  return <div className='bg-white rounded-md my-5 px-4 py-8'>{children}</div>;
};

export default BasicCard;
